import {definePreset} from '@primeng/themes';
import Aura from '@primeng/themes/aura';


const secondaryButtonStyle = {
  color: '{secondaryColor.500}',
  background: '{secondaryBackground.500}',
  icon: {
    color: '{secondaryColor.500}',
    hover: {
      color: '{secondaryColor.500}'
    }
  },
  focus: {
    background: '{secondaryBackground.500}'
  },
  active: {
    color: '{secondaryColor.500}',
    background: '{secondaryBackground.500}'
  },
  hover: {
    color: '{secondaryColor.500}',
    background: '{secondaryBackground.400}',
  }
};

export let FrontendPreset: any;
FrontendPreset = definePreset(Aura, {
  primitive: {
    blue: {
      50: '#e6f5fb', // sehr hell – fast weiß, für Hintergründe
      100: '#e6f5fb', // sehr hell – fast weiß, für Hintergründe
      200: '#bde4f5', // hell – Hover-Effekt, Sekundärelemente
      300: '#8dd0ec', // weich – Linien, Icons, passive States
      400: '#5cbbe3', // leicht betont
      500: '#2ca6d9', // aktiv, hellere Buttons
      600: '#1586bf', // dein Primärton – Standard
      700: '#116fa2', // dunkler – Hover/Fokus
      800: '#0e5c87', // kräftiger – aktive Buttons, Links
      900: '#0b496b', // sehr dunkel – Header, Akzentflächen
      // 900: '#083752', // fast navy – tiefer Kontrast
    },
    /*accent: {
      50: '#FF9696',
      100: '#FF7575',
      200: '#FB0303', // Hauptton
      300: '#E10202',
      400: '#C90202',
      500: '#B20101',
      600: '#970101',
      700: '#820101',
      800: '#6D0000',
      900: '#540000',
      950: '#4C0000'
    },*/
    /*accent: {
      50: '#ffe5e5',
      100: '#ffbfbf',
      200: '#ff9494',
      300: '#ff3d3d',
      400: '#FB0303',
      500: '#C90202',  // Hauptton
      600: '#B20101',
      700: '#970101',
      800: '#6D0000',
      900: '#540000',
      950: '#4C0000'
    },*/
    accent: {
      50: '#ffe5e5',
      100: '#ffbfbf',
      200: '#ff9494',
      300: '#ff6969',
      400: '#ff3d3d',
      500: '#fb0303', // Hauptton
      600: '#e80202',
      700: '#cc0202',
      800: '#b00202',
      850: '#970101',
      900: '#8a0101',
      950: '#6D0000',
      1000: '#540000'
    },
    accent3k: {
      50: '#ffe5e5',
      100: '#ffbfbf',
      200: '#ff9494',
      300: '#ff6969',
      400: '#ff3d3d',
      500: '#fb0303', // Hauptton
      600: '#e80202',
      700: '#cc0202',
      800: '#b00202',
      900: '#8a0101',
    },
    white3k: {
      50: '#ffffff',
      100: '#fdfcfb',
      200: '#faf8f6',
      300: '#f7f5f2',
      400: '#f6f3f0',
      500: '#f5f2ee', // Hauptfarbe 3K Darts White
      600: '#efece8',
      700: '#e7e3dd',
      800: '#dfdbd3',
      900: '#d1ccc2',
      1000: '#c1b8ad', // neue dunklere Stufe
      1100: '#b0a492',
      1200: '#9f9177',
      1300: '#8f7d5c',
      1400: '#7e6950',
      1500: '#6e5545',
    },
    grau: {
      50: '#fcfcfc',
      100: '#fafafa',
      200: '#f5f5f5',
      300: '#ededed',
      400: '#e8e8e8',
      500: '#e3e3e3',
      600: '#b5b5b5',
      700: '#878787',
      800: '#5c5c5c',
      900: '#2e2e2e',
      950: '#171717'
    },
    gray: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121'
    },
    anthrazit: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#475569',
      600: '#374151',
      700: '#303742',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617'
    },
    /*headerBackground: {
      50:  '#e6f3fa',
      100: '#cce4f5',
      200: '#99c9eb',
      300: '#66afe0',
      400: '#338fcd',
      500: '#337AB7',
      600: '#2c669b',
      700: '#24527f',
      800: '#1c3d63',
      900: '#132747',
      950: '#0a121f'
    }*/
    headerBackground: {
      50: '#FF9696',
      100: '#FF7575',
      200: '#FB0303', // Hauptton
      300: '#E10202',
      400: '#C90202',
      500: '#B20101',
      600: '#970101',
      700: '#820101',
      800: '#6D0000',
      900: '#540000',
      950: '#4C0000'
    },
    zinc: {
      50: '#fafafa',
      100: '#f4f4f5',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717a',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      900: '#18181b',
      950: '#09090b'
    }
  },
  semantic: {
    buttonColor: {
      500: '#ffffff'
    },
    secondaryColor: {
      500: '#ffffff'
    },
    buttonBackground: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#3d3d3d',
      600: '#374151',
      700: '#303742',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617'
    },
    secondaryBackground: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#475569',
      600: '#374151',
      700: '#303742',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617'
    },
    primary: {
      50: '{accent.50}',
      100: '{accent.100}',
      200: '{accent.200}',
      300: '{accent.300}',
      400: '{accent.400}',
      500: '{accent.500}',
      600: '{accent.600}',
      700: '{accent.700}',
      800: '{accent.800}',
      850: '{accent.850}',
      900: '{accent.900}',
      950: '{accent.950}'
    },
    secondary: {
      50: '{blau.50}',
      100: '{blau.100}',
      200: '{blau.200}',
      300: '{blau.300}',
      400: '{blau.400}',
      500: '{blau.500}',
      600: '{blau.600}',
      700: '{blau.700}',
      800: '{blau.800}',
      900: '{blau.900}',
      950: '{blau.950}'
    },
    header: {
      50: '{headerBackground.50}',
      100: '{headerBackground.100}',
      200: '{headerBackground.200}',
      300: '{headerBackground.300}',
      400: '{headerBackground.400}',
      500: '{headerBackground.500}',
      600: '{headerBackground.600}',
      700: '{headerBackground.700}',
      800: '{headerBackground.800}',
      900: '{headerBackground.900}',
      950: '{headerBackground.950}'
    },
    green: {
      50: '#e5f6e8', // sehr hell – Success-Hintergrund im Light Theme
      100: '#bde8c2', // weich, hellgrün
      200: '#8fdc99', // hell, freundlich – sekundäre Elemente
      300: '#5fcc70', // lebendig, frisch
      400: '#36b84c', // kräftig, für aktive Zustände
      500: '#00aa00', // dein Basisgrün – Primär Success-Ton
      600: '#258A37', // etwas dunkler – Hover/Active
      700: '#1e6e2d', // tiefgrün – Dark Theme oder Schatten
      800: '#145020', // satt, fast waldgrün
      900: '#0b3213', // sehr dunkel – Kontrastfarbe
    },
    red: {
      50: '#f9e6e6', // sehr hell – dezenter Hintergrund für Light Themes
      100: '#f2bfbf', // weich, fast rosé
      200: '#e68080', // hellrot – Icons, sekundäre Fehlerhinweise
      300: '#d94d4d', // kräftiger, aber nicht grell
      400: '#c91f1f', // intensiver – Hover, Fokus
      500: '#B60000', // dein Hauptrot – Primärton für Fehler/Alert
      600: '#9a0000', // dunkler – Hover/Active
      700: '#7f0000', // tiefrot – Dark Theme
      800: '#5c0000', // fast weinrot
      900: '#3a0000', // sehr dunkel – Text oder Border auf hellen Flächen
    },
    orange: {
      50: '#fff4e5',
      100: '#ffe5bf',
      200: '#ffd38f',
      300: '#ffb84d',
      400: '#ffa426',
      500: '#f39c12',
      600: '#d97f09',
      700: '#b86406',
      800: '#8f4c04',
      900: '#5f3202',
    },
    surface: {
      50: '{grau.50}',
      100: '{grau.100}',
      200: '{grau.200}',
      300: '{grau.300}',
      400: '{grau.400}',
      500: '{grau.500}',
      600: '{grau.600}',
      700: '{grau.700}',
      800: '{grau.800}',
      900: '{grau.900}',
      950: '{grau.950}'
    },
  },
  components: {
    button: {
      colorScheme: {
        secondary: secondaryButtonStyle
      }
    },
    inputtext: {
      border: {
        radius: '4px'
      },
      disabled: {
        color: '{surface.100}',
      }
    },
    message: {
      colorScheme: {
        info: {
          background: '{white3k.400}',
          color: '#000'
        },
        warn: {
          background: '{orange.100}',
          color: '{orange.800}'
        },
        error: {
          background: '{accent3k.100}',
          color: '{accent3k.800}'
        }
      }
    },
    togglebutton: {
      colorScheme: {
        color: '{buttonColor.500}',
        background: '{buttonBackground.500}',
        icon: {
          color: '{buttonColor.500}',
          hover: {
            color: '{buttonColor.500}'
          },
          checked: {
            color: '{buttonColor.500}'
          }
        },
        checked: {
          color: '{buttonColor.500}',
          background: '{header.500}',
          icon: {
            color: '{buttonColor.500}',
            hover: {
              color: '{buttonColor.100}'
            }
          }
        }
      },
    },
    datepicker: {
      colorScheme: {
        dropdown: {
          color: '{buttonColor.500}',
          background: '{buttonBackground.500}',
          border: {
            color: 'rgb(80, 80, 80)'
          },
          hover: {
            color: '{buttonColor.500}',
            background: '{buttonBackground.600}',
            border: {
              color: 'rgb(80, 80, 80)'
            }
          }
        },
        date: {
          selected: {
            // background: '{white3k.700}',
            background: '{accent.200}',
            color: '#000'
          }
        }
      },
    },
    menubar: {
      // background: '#00416F',
      background: '#6D0000',
      color: '#ffffff',
      item: {
        color: '#ffffff',
        icon: {
          color: '#ffffff',
          focus: {
            color: 'var(--accent)'
          }
        },
        label: {
          color: '#ffff00 !important',
          'white-space': 'nowrap',
          focus: {
            color: '{accent3k.600}',
          }
        },
        focus: {
          // background: '#00416F',
          background: '#6D0000'
        }
      },
      subtitle: {
        color: '#ffffff'
      }
    },
    select: {
      color: '#ffffff',
      padding: {
        x: '0.35rem',
        y: '0.43rem'
      },
      overlay: {
        background: '{gray.800}',
        color: '{surface.100}',
      },
      option: {
        color: '{surface.100}',
        selected: {
          background: '{gray.700}',
          color: '{surface.100}',
          focus: {
            background: '{gray.700}',
            color: '{surface.100}',
          }
        },
        focus: {
          background: '{gray.700}',
          color: '{surface.100}',
        }
      },
      disabled: {
        color: '{surface.100}',
      }
    },
    card: {
      color: '{surface.100}',
      background: '{buttonBackground.500}',
      shadow: '0 1px 3px 0 rgba(170,170,170,0.1),0 1px 2px -1px rgba(170,170,170,0.1)',
      body: {
        padding: '0.75rem',
      },
      title: {
        color: '{accent.500}',
      },
      subtitle: {
        color: '{white3k.700}',
      }
    },
    tabs: {
      tablist: {
        background: '{buttonBackground.500}',
      }
    },
    paginator: {
      nav: {
        button: {
          selected: {
            background: '{anthrazit.600}',
            color: '{anthrazit.100}'
          }
        }
      }
    }

    /*togglebutton: {
      background: '#3d3d3d'
    },*/
  }
});

/*
.p-paginator-page.p-paginator-page-selected {
  background: var(--p-paginator-nav-button-selected-background);
  color: var(--p-paginator-nav-button-selected-color);
}
 */

/*.p-selectbutton .p-button {
    // background: #505050FF;
    background: #3d3d3d;
    color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 0.52rem 0.52rem;
    @media screen and (max-width: 960px) {
      padding: 0.46rem 0.2rem;
    }
  }

  .p-selectbutton .p-button:not(.p-highlight):hover,
  .p-selectbutton .p-button.p-highlight:hover {
    background: var(--accent-color);
    color: #fff;
  }
  .p-selectbutton .p-button.p-highlight,
  .p-selectbutton .p-button:focus.p-highlight {
    background: var(--header-background);
    border-color: var(--header-background);
  }*/
